
const apiKey = "Fdx4QkozjOYrJrDhlljgGcfAu7G5crFMeOzE9k3m";
const baseUrl = "https://api.nal.usda.gov/fdc/v1/foods/search"; 

 
export async function handleFormSubmit(event, setSearchedIngradiant) {

    event.preventDefault();
    const foodNameInput = document.getElementById('foodname');
    const foodName = foodNameInput.value.trim();

    if (!foodName) {
        alert('Please enter a food name to search.');
        return; 
    }
    const url = `${baseUrl}?api_key=${apiKey}&query=${encodeURIComponent(foodName)}`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json(); 
        console.log(data.foods.length);

        if (data.foods.length > 0) {
            setSearchedIngradiant(JSON.stringify(data.foods[0])); 
            console.log(data.foods[0]); 
        } else {
            setSearchedIngradiant(''); 
        }

    } catch (error) {
        console.error('Error:', error);
        alert('Failed to fetch data: ' + error.message);
    }
}


export async function handleIngradientList(test, setIngradiantList) {
//     console.log('Type of test:', typeof test);
// console.log('Is test an array?', Array.isArray(test));
// console.log('Value of test:', test);
// let cleanedData = data.map(item => {
//     return item.trim().replace(/[^a-zA-Z0-9\s]/g, '');
// });
//console.log(cleanedData)
    if (!Array.isArray(test)) {
        console.error('Error: test is not an array2');
        console.log(test.value);
        return;
    }
    const fetchPromises = test.map(async (Element) => {
        const url = `${baseUrl}?api_key=${apiKey}&query=${encodeURIComponent(Element)}`;

        try {
            const response = await fetch(url); 
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();  

            if (data.foods.length > 0) {
                console.log(data.foods[0]);  
                return data.foods[0];  
            }
        } catch (error) {
            console.error('Error fetching data for:', Element, error);
        }
        return null; 
    });

    const results = await Promise.all(fetchPromises);
    const validResults = results.filter(item => item !== null);  
    setIngradiantList(validResults);  
}


